"use client"

type ButtonProps = {
    children: React.ReactNode | React.ReactNode[];
    onClick?: any,
    onHover?: any,
    onHoverLeave?: any,
    style?: ButtonStyleType,
    width?: string,
    margin?: string,
    display?: string,
    disabled?: boolean,
    className?: string
}

export default function Button(props: ButtonProps) {
    const style = {
        width: (props.width == undefined) ? "" : props.width,
        margin: (props.margin == undefined) ? "" : props.margin,
        display: (props.display == undefined) ? "" : props.display
    }

    return (
        <button 
            disabled={props.disabled || false}
            className={`btn-default ${props.style?.valueOf() || ""} ${props.className}`}
            onClick={() => {
                if (props.onClick != undefined) {
                    props.onClick()
                }
            }}
            onMouseOver={() => {
                if (props.onHover != undefined) {
                    props.onHover()
                }
            }}
            onMouseOut={() => {
                if (props.onHoverLeave == undefined) {
                    if (props.onHover != undefined) {
                        props.onHover()
                    }
                } else {
                    props.onHoverLeave()
                }
            }}            
            style={style}
        >
            { props.children }
        </button>
    )
}

export enum ButtonStyleType {
    DEFAULT = "",
    SUPERCHAT = "btn-style-superchat",
    FUNDRAISER = "btn-style-fundraiser"
}
